import cn from 'clsx';
import {CART_BUTTON_SINGLE_FOCUS_CLASSES} from '@components/cart/CartButtonClasses';
import {useEffect, useState} from 'react';
import {OutOfStockRouter} from '@components/preorders/out-of-stock-router';
import {AddToCartButton} from '@components/product/global/AddToCart';
import {
  SingleProductFocusProductQuantity
} from '@components/product/ProductPageTemplates/Components/SingleProductFocusWithAssets/SingleProductFocusQuantity';

export const SingleProductFocusAddToCart = ({
  product,
  className,
  buttonText = 'Add to Cart',
  showQuantity = true
}) => {
  const [quantity, setQuantity] = useState(1);

  useEffect(() => {
    setQuantity(1);
  }, [product?.slug]);

  if (product?.isDiscontinued) {
    return <></>;
  }

  const isInStock = product?.currentlyInStock ?? product?.isInStock;
  if (!isInStock) {
    return <OutOfStockRouter product={product} withQuantity={showQuantity} className={className} />;
  }

  const isABundle = product?.category === 'custom-bundle';

  return (
    <>
      <div className='mt-3 space-y-2 mb-3'>
        <div className={cn('flex gap-4', className)}>
          {!isABundle ? (
            <SingleProductFocusProductQuantity quantity={quantity} setQuantity={setQuantity} />
          ) : null}

          <div className={`${isABundle ? 'w-full' : 'w-[300px]'}`}>
            <AddToCartButton
              selectedVariant={product?.selectedVariant ?? product}
              className={CART_BUTTON_SINGLE_FOCUS_CLASSES}
              quantity={quantity}
              addToCartButtonSource={'product-page-button'}>
              {buttonText}
            </AddToCartButton>
          </div>
        </div>
      </div>
    </>
  );
};
